/**
 * Positional colour of one stat tile on the ETL summary card. The values are lower-case because they
 * are the CSS-class suffixes the card renders (`stat--existing`) and `.styled.tsx` selects on, so they
 * deliberately do not match their Pascal-case keys.
 */
export enum EtlSummaryTileVariant {
  Existing = "existing",
  New = "new",
  Removed = "removed",
  Duration = "duration",
}

export interface IEtlSummaryTile {
  labelKey: string;
  value: string;
  variant: EtlSummaryTileVariant;
}
